import { PubSub as PubSubCtor } from '../services';

export const PubSub = new PubSubCtor();
